(function($) {
$(document).ready(function(){
//Product accordion
  $('.accordion-item .item-title').click(function() {
    if ($(this).closest('.accordion-item').hasClass('active')) {
        $(this).closest('.accordion-item').removeClass('active');
      $(this).siblings('.item-content').slideUp();
    } 
    else {
      $(this).closest('.accordion-item').addClass('active').siblings('.accordion-item').removeClass('active');
      $(this).closest('.accordion-item').siblings('.accordion-item').find('.item-content').slideUp();
      $(this).siblings('.item-content').slideDown();
    }
  });

  checkVariant();
  $('.ProductForm__Variants .HorizontalList__Item').click(function(){
    checkVariant();
  });
  
  $('.Product__Slideshow .flickity-enabled').flickity({
  // options
    lazyLoad: true
  });
  
  $('.ProductList.ProductList--carousel').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    pageDots: true
  });
  setTimeout(function () {
    $('.card-visual-box__button-wrapper .quick-add-button.quick-add__button').click(function() {
      $(this).parent().addClass('is-active');
    });
    $(".ProductItem .quick-shop-form__header.text-left .shop-form-close").click(function(){
      $(this).parents(".quick-add").removeClass("is-active");
    });
  }, 2000);
});
})(jQuery);

/************* On variant change ******************/
function checkVariant() {
  //Get product JSON
  var handle = window.Shopify.routes.root + 'products/' + $('.product-handle').text()+'.js';
  //Check size swatch
  jQuery.getJSON(handle, function(product) {
    // console.log(product);

    //Check order of variants 
    var orderVariants = $(".order-variants").text().split(',');
    // console.log(orderVariants);

    //Get values are selected
    for (var i = 0; i < orderVariants.length; i++) {
      let swatch_option = ".swatch-" + orderVariants[i] + ' li';
      let listItem = $(swatch_option);
      listItem.each(function(idx, li) {
        let itemValue = $(li).find('input:checked').val();
        if(itemValue) {
          // console.log('itemValue: '+itemValue);
        }
      });
    }
    // Get first option Selected
    let swatch_option1 = ".swatch-" + orderVariants[0] + ' li';
    let listItem1 = $(swatch_option1);
    var firstSelected = '';
    listItem1.each(function(idx, li) {
      let firstValue = $(li).find('input:checked').val();
      if(firstValue) {
        firstSelected = firstValue;
      }
    });

    //Get second option Selected
    let swatch_option2 = ".swatch-" + orderVariants[1] + ' li';
    var listItem2 = $(swatch_option2);
    var secondSelected = '';
    listItem2.each(function(idx, li) {
      let secondValue = $(li).find('input:checked').val();
      if(secondValue) {
        secondSelected = secondValue;
      }
    });
    
    //Get third option Selected
    let swatch_option3 = ".swatch-" + orderVariants[2] + ' li';
    let listItem3 = $(swatch_option3);
    var thirdSelected = '';
    listItem3.each(function(idx, li) {
      let thirdValue = $(li).find('input:checked').val();
      if(thirdValue) {
        thirdSelected = thirdValue;
      }
    });

    // Check option name
    listItem2.each(function(idx, li) {
      let secondValue = $(li).find('input').val();
      let variants = product.variants;
      let available = 1;
      let existed = 0;
      for (let i = 0; i < variants.length; i++) {
        if (variants[i].option1.length) {
          var firstOption = ".swatch-" + orderVariants[0] + ' li';
          firstOption = variants[i].option1;
        }

        if (variants[i].option2.length) {
          var secondOption = ".swatch-" + orderVariants[1] + ' li';
            secondOption = variants[i].option2;
        }

        if (variants[i].option3 != null) {
          if (variants[i].option3.length) {
            var thirdOption = ".swatch-" + orderVariants[2] + ' li';
              thirdOption = variants[i].option3;
          }
        }

        //Check if variant available
        if(firstOption == firstSelected && secondOption == secondValue && thirdOption == thirdSelected) {
          if(variants[i].available) {
            available = 1;
          } else {
            available = 0;
          } 
        }
        //Check if variant exist
        if (thirdOption != null) {
          if(firstOption == firstSelected && thirdOption == thirdSelected) {
            if(secondOption == secondValue) existed = 1;
          } 
        } 
        else {
          if(firstOption == firstSelected) {
            if(secondOption == secondValue) existed = 1;
          } else if (secondSelected == secondOption) {
            if(firstOption == firstSelected) existed = 1;
          }
        }
      }

      //Add class available
      if(available == 0) {
        $(li).addClass('oos');
      } else {
        $(li).removeClass('oos');
      }
      //Add class not exist
      if(existed == 0) {
        $(li).addClass('not-exist');
      } else {
        $(li).removeClass('not-exist');
      }
    });
  });
}